import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

// Add profile URLs under `links` (github, linkedin, dribbble, instagram) and they appear in the footer.
export const siteConfig: SiteConfig = {
    name: "Ansam Yaseen",
    shortName: "ANSAM",
    role: "Creative Web Developer",
    description: "Ansam Yaseen is a creative full-stack web developer building fast, responsive and animated websites that blend clean code with bold, thoughtful design.",
    availability: "Available for new projects",
    year: '2026',
    url: getOrigin(),
    links: {}
}
